import { createAsyncThunk } from "@reduxjs/toolkit";
import fetchAPI from "../../utils/axios";
import { getEndPointByAgeGroup } from "../../utils/Constants";
import { getCurrentBookIdFromLocalStorage } from "../../utils/localStorage";

export const getListOfBooksByAgeFromServer = createAsyncThunk(
    'books/getBookList', async (ageGroupOpt, thunkApi) => {
        try {
            const response = await fetchAPI.get(getEndPointByAgeGroup(ageGroupOpt));
            return response.data;
        } catch (error) {
            let message = error.response.data.error;
            return thunkApi.rejectWithValue(message);
        }
    }
);
export const requestToCreateNewBook = createAsyncThunk(
    'book/addBook', async (payload, thunkAPI) => {
        try {
            const { bookObj, ageGroupOpt } = payload;
            const response = await fetchAPI.post(getEndPointByAgeGroup(ageGroupOpt), bookObj);
            return response.data;
        } catch(err) {
            let message = err.response.data.error;
            return thunkAPI.rejectWithValue(message);
        }
    }
);
export const requestToUpdateBook = createAsyncThunk(
    'book/updateBook', async (payload, thunkAPI) => {
        try {
            const { bookObj, ageGroupOpt } = payload;
            const response = await fetchAPI.put(getEndPointByAgeGroup(ageGroupOpt) + `/${getCurrentBookIdFromLocalStorage()}`, bookObj);
            return response.data;
        } catch (err) {
            let message = err.response.data.error;
            return thunkAPI.rejectWithValue(message);
        }
    }
);
export const requestToGetBooksByIdFromServer = createAsyncThunk(
    'book/getBookById', async (obj, thunkAPI) => {
        try {
            const { id, ageGroupOpt } = obj;
            const response = await fetchAPI.get(getEndPointByAgeGroup(ageGroupOpt)+ `/${id}`);
            return response.data;
        } catch (err) {
            let message = err.response.data.error;
            return thunkAPI.rejectWithValue(message);
        }
    }
);